import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth51: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: 'M186.9 99.5 186.6 111.8 186.1 116.2 184.5 120.7 182.5 123.6 179.4 125.9 19.3 125.9 16.2 121.7 15.1 110.7 17.1 97.2 20.4 92.6 184.1 93.4 186.9 99.5',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M166.5,132.1c-40.5-27.2,13.6-47.4,13.6-47.4l1.8,4.4,2.1,4.2,2.8,6.1-.3,12.3-.2,4.1-1.9,4.9-1.6,2.7-7.6,5.4-8.7,3.4h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29.9,79.9c51.6,31.4-4.5,52.1-4.5,52.1l-2.9-1.6-3.4-4.6-3.6-5.1-.9-5.4.4-4.7.2-6,1.8-7.5,1.8-3.9,2-3,4.3-5.7,4.8-4.6h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M186.2,98.7l-3.4-10.5-4.6-10.2-5.4-7.9-7.9-7.1-9.1-7.9-10.2-5.9-11.1-3.4-8.6-.9-12.3-.2-11.6.2-7.5,1.1-7.9,1.2-12.9,3.2-11.1,4.8-13.2,7.3-9.8,7.3-8,7.7-9.6,10.7-3.6,6.8-2.1,5.2-.7,7-.5,7.5c78.9-25.5,170.9,0,170.9,0',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M132.5,84h-54.1s31.1-73,54.1,0Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M15.1,114.7l1.7,9.8,7.6,8.2,9.6,5.8,14.8,8.2,5.6,5.2,11.7,7.6,11.1,6.2,11.3,4.1,11.6-.4,14-4.4,12.2-5.4,10.9-7.6,9.7-8.3,7.4-5.3,7.9-3.7,13.5-5.3,6.2-4.1,1.9-2.9,2.1-5.4v-2.3s-91.5-25.4-170.9,0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M109.5,166.7c-11,4.2-21.2,3.8-31.3-1.1s-22.1-13.3-32.8-21l-16-8.8c-18.1-9.9-17.3-34.4-5.9-48.6,21.2-26.5,49.3-41,83.7-42.3,28.3-1,41.6,2.5,61.6,21.4,14.2,13.3,24,41.5,14.4,56.9-5.8,9.3-22.3,7-41,24.9s-20.5,14-32.6,18.6Z',
			},
		},
	},
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M174.4,89.8l1.3-19.5-.2-17.9c-56.1,9.9-1.1,37.4-1.1,37.4Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M21.6,90.8l-.5-19.4,1.7-16.4c49.1,12.8-1.2,35.8-1.2,35.8Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '175.9 38.6 175.3 33.2 172.7 26.7 168.3 20.6 160.8 17.7 153.4 15.8 141.1 14.1 122.2 14.1 109.8 14.5 101.9 16 91.8 17.4 84 18.7 69.3 18.7 64.3 19.5 58.8 20 52.5 21.9 47.9 23.9 42.3 27.7 38.5 31.5 33.5 36.5 28.2 43.2 175.7 43.2 175.9 38.6',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M114.1,105.7A14,14 0 1 0 86.1,105.7A14,14 0 1 0 114.1,105.7Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M160.4,138.2C113.8,81.8,124.3,14,124.3,14l7.6-.2,10.5.4,6.7.8,7.8,1.7,11.3,3.8,4,4.8,3.4,9.6v8.2s-.2,9.3-.2,9.3l.4,22.5-1.5,14.9v5.2s-2.5,16.2-2.5,16.2l-3.4,12.8-8,14.3h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M74.6,19c10.2,75.1-33.8,121.5-33.8,121.5l-6.1-6.7-3.8-7.5-4.2-10.9-2.9-9.4-1.9-11.5-1.3-11.1-.2-7.1.4-8.2.4-6.7,1.5-6.3,1.9-5.4,3.8-7.3,5.2-6.7,4.8-4.2,4.8-5,5.4-3.4,10.1-3.1,6.5-1.3h9.6s-.2.3-.2.3Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M160.4,138.3l-4.2,14.3c-61.1,33.8-109.1,2.3-109.1,2.3l-6.1-14.7c60,37.5,119.4-1.9,119.4-1.9h0Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M175.4,33.6l.6,5.4.4,11.1v10.1s-.6,9-.6,9v9.2s-.8,8.2-.8,8.2l-.8,10.1-1,8-1.7,8-3.8,14-7.3,12c-68,39.9-119.4,1.9-119.4,1.9l-3.6-3.8-4.8-5.7-3.1-8-3.4-9.2-2.7-9.6-1.3-8.2-1.7-10.7-.4-7.1.4-13,1.1-7.1,3.2-9.4,4-7.3,3.8-5.2,4.8-5,5.9-4.6,4.6-2.7,7.6-3.1,8.8-2.3,9-.4,10.7.6,7.8-1.3,5.9-1,7.3-1.3,6.7-.6,7.3-.6,9.4-.4,8.4.2,12.4,1.3,7.8,1,10.7,3.6,4.6,5.7,3.1,7.8v.4Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M162.8,134.8c-38.6,29-86.5,33.7-124.3,1.1-4.1-3.5-6.8-9.7-9.1-15.3-7.6-18.9-9.8-39.8-7.6-59.9,1.2-11.1,6.9-19.3,13.9-27.1s19.2-14.7,32.3-14.7,25.7-2,39-3.8c17.9-2.4,35.9-.9,53.6,2.5,7.5,1.5,13.6,7.6,14.3,15.5,2.3,24.1.7,48.2-2.2,72.4s-4.3,20.1-9.8,29.2Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M56.8,409.2l73.7.7c-33.4-131.3-73.7-.7-73.7-.7Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M17.8,448.6c54.8-21.7-3.1-32.4-3.1-32.4l-1,7.9.7,12.7,3.4,11.7h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M176,454.7v-34.8c-61.3,10.7,0,34.8,0,34.8Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '175.2 471.3 173 477.5 168.2 483.9 161.1 488.5 148.6 491 134.7 492.5 107.8 492.4 102.8 491.8 94 490.5 85.4 488.4 77.4 487 69.3 485.3 61.3 484.8 49.5 482.6 41.3 479.1 33.1 472 27.1 464.7 175.3 464.7 175.2 471.3',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M155.7,338.8c-57.4-44.4-116.9-1.5-116.9-1.5l-10.1,19.7c75.1-57.4,131.8-2,131.8-2,0,0-4.8-16.2-4.8-16.2Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M123.4,492.6c-7.2-71.8,37.3-137.6,37.3-137.6l12,27,3,22.1.4,15.8v34.8s-.8,16.6-.8,16.6l-2.3,6.2-4.7,6.4-7.1,4.6-12.5,2.5-13.9,1.6h-11.5s.1,0,.1,0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M28.5,357c36.3,45.8,31.4,128,31.4,128l-9.9-2-8.8-3.8-6.9-5.4-7.3-9.1-3.4-4.1-5.9-12.1-3.4-11.7.4-20.7v-7.3s1.6-9.4,1.6-9.4l1.4-7.9,2.2-10.4,2.4-10.1,6.4-14h-.2Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M160.5,354.9l7.2,13.4,4.8,13.6s3.5,21.5,3.4,21.5v15.7s.2,20.7.2,20.7l-.9,31.3-2.3,6.2-5,6.9-6.4,4.1-12.9,2.6s-13.2,1.6-13.2,1.7h-27.1s-14.3-2.1-14.3-2.1l-24.2-5.3-9.8-.3-9.9-2-8.1-3.4-7.6-5.7-11.4-14.6-5.2-10.7-3.4-11.7-.8-7.9,1.1-20.1,7.6-37.8,6.4-14c75.6-58.2,131.8-2,131.8-2h0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M155.6,489.6c-21.3,3.9-45.1,4.7-66.1-.3-10.2-2.4-20.3-3.9-30.7-5.2-12.9-1.6-23.3-7.8-31.1-18s-11.4-18.7-12.5-30.3c-2.2-23.1,1.9-57,12.8-78,29.8-29.7,72.9-46.7,110.3-22.3s15.1,10.7,20.9,18l6.7,12.2c5.6,10.2,7.5,21,8.5,32.6,2,23.2,2.3,46.2.4,69.2-1,11.7-8,19.9-19.2,21.9Z',
			},
		},
	},
};
